export default __webpack_public_path__ + "static/media/acropass-ac-care-set-of-3-temporary.1ffa85b5.png";